import React, { useEffect, useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import { ProgressBarProfile } from "../../Profiles/components/ProgressProfile";
import { Card } from "react-bootstrap";
import { CalculatePersentaseProfile } from "../../Profiles/_core/_core";
import { DOWNLOAD_REQUEST_DOC, GET_DOC_LIST } from "../../../StudentNewComming/APIS";
import { RSAencryptData } from "../../../StudentNewComming/Documents/RSAEnc";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function WProgressProfile({ student }) {
  const registered_id = student?.registered_id || "";
  const doc_req_name = `doc_list_${student?.studentid}`;
  const local_name_pp = `blob_pp_${student.studentid}`;
  const total_calculate = useMemo(() => {
    return CalculatePersentaseProfile(student);
  }, [student]);

  const doc_type = "strg.doc.type.pasfoto";
  const status_file = "strg.file.status.uploaded";

  const [profilePic, setProfilePic] = useState("");

  const OWNER_DOC = async () => {
    setProfilePic("");
    const param = { owner: registered_id };
    const objData = JSON.stringify(param);
    const rsaEnc = RSAencryptData(objData);
    const formData = new FormData();
    formData.append("data", rsaEnc);
    const results = await GET_DOC_LIST(formData);
    if (results.result === "success") {
      if (results.data.data && Object.values(results.data.data).length > 0) {
        const get_active_doc = results.data.data.filter(
          (item) => item.status === status_file
        );
        const find_pp = get_active_doc.find((item) => item.doc_type === doc_type && item.verify === 1);
        setProfilePic(find_pp);
        localStorage.setItem(doc_req_name, JSON.stringify(get_active_doc));
      } else {
        localStorage.setItem(doc_req_name, "");
      }
    } else {
      localStorage.setItem(doc_req_name, "");
    }
  };

  useEffect(() => {
    const loadData2 = async () => {
      const storedData = localStorage.getItem(doc_req_name);
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          console.log(data);
        } catch (error) {
          console.error("Error parsing stored data:", error);
          await OWNER_DOC();
        }
      } else {
        await OWNER_DOC();
      }
    };

    if (registered_id && registered_id !== "") {
      loadData2();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [registered_id]);

  useEffect(async ()=>{
    if(profilePic && Object.values(profilePic).length > 0){
        const file_id = profilePic?.file_id || "";
        if(file_id){
            await RenderPP(file_id);
        }
    }
  },[profilePic])

  const RenderPP = async (file_id) => {
    const objData = JSON.stringify({
      file_id: file_id,
      user: AuthDecode?.identity?.email || "",
    });
    const rsaEnc = RSAencryptData(objData);
    const formData = new FormData();
    formData.append("data", rsaEnc);
    formData.append("file", []);
    const download = await DOWNLOAD_REQUEST_DOC(formData);
    if (download.status === 200) {
      if (download.data.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = function () {
          const base64data = reader.result;
          localStorage.setItem(local_name_pp, base64data);
        };
        reader.readAsDataURL(download.data);
      }else{
        localStorage.setItem(local_name_pp,'');
      }
    } else {
      localStorage.setItem(local_name_pp,'');
    }
  };

  if (total_calculate !== 100) {
    return (
      <Card>
        <Card.Body>
          <div className="">
            <h4 className="text-center">Profile Completion</h4>
            <ProgressBarProfile
              total_percentage={total_calculate?.completion_percentage || 0}
              title="Progress"
            />
            <div className="mt-5 text-center">
              <p className="mb-5 font-size-h5">
                In order to complete your profile, please provide us with the
                required information.
              </p>
              <Link
                to="/profile"
                className="btn btn-lg px-15 btn-success rounded-pill font-size-h4 font-weight-bold"
              >
                Update your profile
              </Link>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  } else {
    return null;
  }
}
